import { render, staticRenderFns } from "./Bread.vue?vue&type=template&id=0272c708"
import script from "./Bread.vue?vue&type=script&lang=js"
export * from "./Bread.vue?vue&type=script&lang=js"
import style0 from "./Bread.vue?vue&type=style&index=0&id=0272c708&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports